import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-booking-error',
  standalone: false,
  templateUrl: './booking-error.component.html',
  styleUrls: ['./booking-error.component.scss'],
})
export class BookingErrorComponent {
  title = input('Something went wrong');
  message = input('Please try again later.');
  buttonLabel = input<string>();
  icon = input('warning_amber');

  buttonClick = output<void>();

  onButtonClick(): void {
    this.buttonClick.emit();
  }
}
